import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../../components/formulario/tableStyled";
import { useEffect, useRef, Suspense, lazy } from 'react';
import LoadingGif from "../../../../../components/loading";
import { UseListMembros } from "../../context/listMembrosConexoes";

const Row = lazy(() => import('./rows'))


export default function TabelaConexao() {

  const devRef = useRef<HTMLDivElement>(null);

  const { filas, setFilas, pgs } = UseListMembros()

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          setFilas({ fila: filas.fila++, tamanho: filas?.tamanho + 300 });
        }
      })
    }
  }, [devRef, pgs]);

  return (
    <>
      <Tabler>
        <Suspense fallback={<LoadingGif />}>
          <CorpoTable ref={devRef}>
            <Tabela>
              <>
                <TabelaCabeca>
                  <tr>
                    <th>Nome</th>
                    <th>Telefone</th>
                    <th>E-mail</th>
                    <th>Sede</th>
                    <th>PG</th>
                    <th>Inscrição</th>
                    <th>Aceitar</th>
                  </tr>
                </TabelaCabeca>
                <TabelaCorpo >
                  <Row />
                </TabelaCorpo>
              </>
            </Tabela>
          </CorpoTable>
        </Suspense>

      </Tabler>
    </>
  )
}
